import { gsap } from "gsap";
import { power1, power2, power3, power4 } from "gsap";

/* Accordion box JS
---------------------------------------------------------------------*/
$('.accordion-databox').each(function() {
    var $accordion = $(this),
        $accordionTrigger = $accordion.find('.accordion-trigger'),
        $accordionDatabox = $accordion.find('.accordion-data');
        
    // $accordionTrigger.first().addClass('open');
    // $accordionDatabox.first().show();
    
    $accordionTrigger.on('click',function (e) {
        var $this = $(this);
        var $accordionData = $this.next('.accordion-data');
        if( $accordionData.is($accordionDatabox) &&  $accordionData.is(':visible') ){
            $this.removeClass('open');
            $accordionData.slideUp(350);
            e.preventDefault();
        } else {
            $accordionTrigger.removeClass('open');
            $this.addClass('open');
            $accordionDatabox.slideUp(350);
            $accordionData.slideDown(350);
        }
    });
});